import { AfterViewInit, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

/**
 * * Componente padrão, simplificado, de paginação do Apolo.
 */
@Component({
  selector: 'ui-simple-pagination',
  templateUrl: './simple-pagination.component.html',
  styleUrls: ['./simple-pagination.component.scss']
})
export class SimplePaginationComponent implements OnInit, AfterViewInit {

  /**
   * * Página atual.
   */
  @Input() page: number = 1;

  /**
   * * Total de elementos.
   */
  @Input() collectionSize: number = 0;

  /**
   * * Tamanho da página
   */
  @Input() pageSize: number = 25;

  /**
   * * Evento da troca de página.
   */
  @Output() pgEvent: EventEmitter<number> = new EventEmitter<number>();

  constructor() { }

  ngOnInit(): void {
  }

  ngAfterViewInit() {
    setTimeout(() => {
      this.jumpToPg(1);
    }, 500);
  }

  getAllPages(): number {
    let totalPages = Math.floor(this.collectionSize / this.pageSize);
    if (this.collectionSize % this.pageSize != 0)
        totalPages += 1
    return totalPages;
  }

  jumpToPg(value: number) {
    const page = value;
    const allPages = this.getAllPages();
    if (page > allPages) {
      this.page = allPages; // muda para a ultima pagina
    } else if (page < 1) {
      this.page = 1; // muda para a primeira pagina
    } else {
      this.page = page; // configura a pagina
    }

    this.pgEvent.emit(this.page);

  }

  evtJumpToPg(event: Event): void {
    const value = (event.target as HTMLInputElement).value;
    this.jumpToPg(parseInt(value));
  }

  previousPg() {
    this.jumpToPg(this.page - 1);
  }

  nextPg() {
    this.jumpToPg(this.page + 1);
  }

  getFirst(): number {
    if (this.collectionSize == 0 || this.page == 0) {
      return 0;
    }
    return (this.page - 1) * this.pageSize + 1;
  }

  getLast(): number {
    if (this.collectionSize == 0) {
      return 0;
    }
    const last = this.page * this.pageSize;
    return last <= this.collectionSize ? last : this.collectionSize;
  }

}
